import ACTION_TYPES from './ActionTypes';

export const fetchData = (): any => ({
    type: ACTION_TYPES.API_PENDING,
});

export const fetchSuccess = (data: any): any => ({
    type: ACTION_TYPES.API_SUCCESS,
    payload: data,
});

export const fetchError = (error: any): any => ({
    type: ACTION_TYPES.API_ERROR,
    payload: error,
});

export const serviceLoaderStart = (): any => ({
    type: ACTION_TYPES.API_LOADER_START,
});

export const serviceLoaderStopOnSuccess = (): any => ({
    type: ACTION_TYPES.API_LOADER_SUCCESS,
});

export const serviceLoaderStopOnError = (): any => ({
    type: ACTION_TYPES.API_LOADER_ERROR,
});


export const fetchUserError = (error: any): any => ({
    type: ACTION_TYPES.USER_ERROR,
    payload: error,
});

export const fetchUserData = (): any => ({
    type: ACTION_TYPES.USER_PENDING,
});

export const fetchUserSuccess = (data: any): any => ({
    type: ACTION_TYPES.USER_SUCCESS,
    payload: data,
});


export const logoutUser = (error: any): any => ({
    type: ACTION_TYPES.LOGOUT,
    payload: error,
});
